export default __webpack_public_path__ + "static/media/aviso_privacidad_callejeritos.74cbae48.pdf";